__turbopack_context__.v({
  "addonCard": "index-module-scss-module__wETaDG__addonCard",
  "addonCardSelected": "index-module-scss-module__wETaDG__addonCardSelected",
  "addonDescription": "index-module-scss-module__wETaDG__addonDescription",
  "addonInfo": "index-module-scss-module__wETaDG__addonInfo",
  "addonList": "index-module-scss-module__wETaDG__addonList",
  "addonPrice": "index-module-scss-module__wETaDG__addonPrice",
  "addonTitle": "index-module-scss-module__wETaDG__addonTitle",
  "checkbox": "index-module-scss-module__wETaDG__checkbox",
  "checkboxChecked": "index-module-scss-module__wETaDG__checkboxChecked",
  "header": "index-module-scss-module__wETaDG__header",
  "title": "index-module-scss-module__wETaDG__title",
});
